module.exports = __webpack_public_path__ + "static/dot-bg.4bd47a69.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/dot-bg.png
// module id = 1007
// module chunks = 2